import React, { useState  } from 'react';
import axios from "axios";
// import { connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import {Table, Column, Cell} from 'fixed-data-table-2';
import "fixed-data-table-2/dist/fixed-data-table.css";
import { Button } from '@mui/material';
import moment from 'moment';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};
// function createData(
//     name: string,
//     calories: number,
//     fat: number,
//     carbs: number,
//     protein: number,
// ) {
// return { name, calories, fat, carbs, protein };
// }

// const rows = [
// createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
// createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
// createData('Eclair', 262, 16.0, 24, 6.0),
// createData('Cupcake', 305, 3.7, 67, 4.3),
// createData('Gingerbread', 356, 16.0, 49, 3.9),
// ];
// type Props = {
//     toggleState: () => void;
// };

function NewsTable(props){

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    


    // React.useEffect(() => {
    //     let url = "http://localhost:5000/v1/recruiting/getNewsList";
    //     axios.get(url).then((response) => {
    //       console.log(response.data,"newslist")
    //       setnewslist(response.data);
    //     });
    // }, []);

    // React.useEffect(() => {
    //     console.log(props)
    //     if(props.List){//編集で記事を読み取りしたとき
    //         console.log(props.List,"List")
    //         setnewslist(props.List);
    //     }else{
            
    //     }
    //   }, [props]);

    return (
        <div id="tcblog" style={{}}>
            {/* {newslist.length?<Table className='Table' rowHeight={35} rowsCount={newslist.length} width={350} height={500} headerHeight={40}>
                <Column header={<Cell>編集</Cell>} 
                    cell={({rowIndex, ...props}) => ( <Cell className='iconbox' {...props}><IconButton id={newslist[rowIndex].id} 
                    onClick={() => editClick(newslist[rowIndex])}
                    aria-label="edit" size="small"><ModeEditOutlineIcon /></IconButton></Cell>)} width={50}
                />
                <Column header={<Cell>タイトル</Cell>} cell={({rowIndex, ...props}) => ( <Cell {...props}>{newslist[rowIndex].title}</Cell>)} width={250}/>
                <Column header={<Cell>カテゴリー</Cell>} cell={({rowIndex, ...props}) => (<Cell {...props}>{newslist[rowIndex].category === 0? "採用イベント": "コラム"}</Cell>)} width={120}/>
                <Column header={<Cell>公開</Cell>} cell={({rowIndex, ...props}) => (<Cell {...props}>{newslist[rowIndex].web_open === 0? "非公開": "公開"}</Cell>)} width={80}/>
                <Column header={<Cell>公開日</Cell>} cell={({rowIndex, ...props}) => (<Cell {...props}>{!newslist[rowIndex].opened_at ?null:moment(newslist[rowIndex].opened_at).format("YYYY.MM.DD")}</Cell>)} width={150}/>
            </Table>:""} */}

            <Table className='Table' rowHeight={45} rowsCount={2} width={600} height={600} headerHeight={40}>
                <Column header={<Cell>編集</Cell>} 
                    cell={<Cell className='iconbox'><IconButton onClick={handleOpen}
                    aria-label="edit" size="small"><ModeEditOutlineIcon /></IconButton></Cell>} width={50}
                />
                <Column header={<Cell>名前</Cell>} cell={<Cell>山田　花子</Cell>} width={300}/>
                <Column header={<Cell>LINE</Cell>} cell={<Cell><Button size="small" variant="contained" sx={"background-color:rgb(92, 184, 92);"}>LINE表示</Button></Cell>} width={100}/>
                <Column header={<Cell>新卒・中途</Cell>} cell={<Cell></Cell>} width={100}/>
            </Table>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">編集</Typography>
                    <TextField style={{marginTop:'20px'}} id="outlined-basic" label="名前" variant="outlined" fullWidth />
                    <div style={{paddingTop:'20px'}}>
                        <FormLabel component="legend">新卒・中途</FormLabel>
                        <FormGroup style={{paddingLeft:'10px'}}>
                            <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="新卒" />
                            <FormControlLabel control={<Checkbox size="small" />} label="中途" />
                        </FormGroup>
                    </div>
                    <div style={{textAlign:'right',marginBottom:'10px',}}>
                        <Button size="small" variant="contained">登録</Button>
                    </div>
                </Box>
            </Modal>

            {/* <Table className='Table' rowHeight={70} rowsCount={2} width={window.innerWidth - 400} height={window.innerHeight - 60} headerHeight={40}>
                <Column header={<Cell>反響日</Cell>} 
                cell={<Cell className="cellp_none">
                    <table className="in_table">
                        <tbody>
                            <tr>
                                <td className="th" style={{ width: "80px" }}></td>
                                <td className='td' colSpan={2}>
                                    <span className="title">反響日1　</span>
                                    2023年2月6日
                                </td>
                            </tr>

                            <tr>
                                <td className="th" style={{ width: "80px" }}>
                                    <Button size="small" variant="contained">詳細</Button>
                                </td>
                                <td className='td' colSpan={2} >
                                    <span className="title">受信日時　</span>
                                    2023年2月6日
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Cell>} width={320}/>

                <Column header={<Cell>お名前</Cell>} 
                cell={<Cell className="cellp_none">
                    <table className="in_table in_table1">
                        <tbody>
                            <tr>
                                <td className="th" style={{ width: "80px" }}>名前</td>
                                <td className='td' colSpan={2}>
                                    山田　花子
                                </td>
                            </tr>

                            <tr>
                                <td className="th" style={{ width: "80px" }}>
                                最終閲覧
                                </td>
                                <td className='td' colSpan={2}>
                                    <span className="title"></span>
                                    2023年2月6日
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Cell>} width={320}/>

                <Column header={<Cell>連絡先</Cell>} 
                cell={<Cell className="cellp_none">
                    <table className="in_table in_table2">
                        <tbody>
                            <tr>
                                <td className="th" style={{ width: "80px" }}>TEL</td>
                                <td className='td' colSpan={2}>
                                    080-8888-8888
                                </td>
                            </tr>

                            <tr>
                                <td className="th" style={{ width: "80px" }}>メール</td>
                                <td className='td' colSpan={2}>
                                    aaa@gmail.com
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Cell>} width={250}/>       

                <Column header={<Cell>媒体</Cell>} 
                cell={<Cell className="cellp_none">
                    <table className="in_table in_table3">
                        <tbody>
                            <tr>
                                <td className="th" style={{ width: "80px" }}>媒体</td>
                                <td className='td' colSpan={2}>
                                    リクルート
                                </td>
                            </tr>

                            <tr>
                                <td className="th" style={{ width: "80px" }}></td>
                                <td className='td' colSpan={2}>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Cell>} width={200}/>          
            </Table>*/}
            

            <style jsx="true">{
                `
                .Table{
                    text-align:left;
                    font-size:16px;
                }
                .cellp_none .public_fixedDataTableCell_cellContent{
                    padding:0;
                }
                .in_table {
                    border-collapse: collapse;
                    table-layout: fixed;
                    padding: 0;
                    width:320px;
                }
                .in_table td{
                    border-top:0;
                    border:1px solid #d3d3d3;
                }
                .in_table .th{
                    padding: 0;
                    height: 33px;
                    border-color: #d3d3d3;
                    border-width: 0 1px 1px 0;
                    white-space: nowrap;
                    width: 80px;
                    text-align: center;
                    font-weight: 700;
                }
                .in_table .td{
                    padding: 0 0 0 10px;
                    height: 33px;
                    border-color: #d3d3d3;
                    border-width: 0 1px 1px 0;
                    white-space: nowrap;
                }
                .in_table td .title{
                    font-weight: 700;
                }
                .in_table2{
                    width:250px;
                }
                .in_table3{
                    width:200px;
                }
                .MuiButton-containedSizeSmall {
                    padding: 4px 10px;
                    font-size: 0.8125rem;
                }

                `
            }
            </style>
        </div>
    );
    
};
// root.render(<HelloMessage name="Taylor" />);
export default NewsTable;




